module.exports = __webpack_public_path__ + "img/img_4.f6ce0ec9.png";